// extracted by mini-css-extract-plugin
module.exports = {"rowHeader":"DashboardReportSexAgeTable_rowHeader__3Gt7D","columnHeader":"DashboardReportSexAgeTable_columnHeader__ku4Sg","table":"DashboardReportSexAgeTable_table__2-Sxn"};